export default __webpack_public_path__ + "static/media/VideoPng.c11f22ea.png";